import { useSelector } from 'react-redux';
import { ActionCell } from '../columns';
import { getAuthTeamMember } from 'store/authentication/selectors';
import { SizedCell } from '__components/Kizen/Table';

export const ApiKeysActionCell = ({ t, canRemove = true, data, ...props }) => {
  const teamMember = useSelector(getAuthTeamMember);

  const options = [
    teamMember &&
      teamMember.id === data.employee?.id && {
        value: 'onKeyView',
        label: t('View API Key'),
      },
    canRemove && { value: 'onKeyDelete', label: t('Delete API Key') },
  ].filter(Boolean);

  return options.length ? (
    <ActionCell
      options={options}
      title={t('Actions')}
      t={t}
      data={data}
      {...props}
    />
  ) : (
    <SizedCell {...props} />
  );
};
